import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function regionComboReducer(state= initialState.regionCombo, action){
	switch(action.type){
		case types.GET_REGIONS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}